import { createFileRoute } from '@tanstack/react-router';

import { ProfileScreen } from '@/features/profile/components/ProfileScreen';

export const Route = createFileRoute('/client/profile')({
  component: ClientProfileRoute,
});

function ClientProfileRoute() {
  return <ProfileScreen />;
}
